/**
 * Update: 18/04/2024 - Mariam Bawa - Refactor code to use IncomeAttributeTableFragmentGenerator to generate table content and cast data to IncomeAttributeLookupObject
*  Update: 18/04/2024 - Mariam Bawa - Added thead element in markup to meet AODA standards. 
Element is then hidden from UI using CSS
*/
import React from "react";
import IncomeAttributeLookupObject from "../../../types/lookups/IncomeAttributeLookupObject";
import IncomeAttributeTableFragmentGenerator from "../../../utils/TableGenerator/IncomeAttributeTableFragmentGenerator";
import { incomeAttributePercentMatcher } from "../../../utils/context/FormErrorContext";

export interface RevenueTabProps {
  handleTotalIncome: (newAmt: number | undefined | null, name: string, oldAmt: number | undefined | null) => void,
  handleTotalLoss?: (newAmt: number | undefined | null, name: string, oldAmt: number | undefined | null) => void,
  handleCommentChange: (value: string, name: string) => void,
  lookups: IncomeAttributeLookupObject[],
  name: string,
  incomeAttributes?: Record<string, unknown>[],
  lookupType: string;
}

export default function RevenueTab(props: RevenueTabProps): JSX.Element {
  const isLossTab = props.name === 'rentalLoss';
  const valueChangeHandler = (isLossTab && props.handleTotalLoss !== undefined) ? props.handleTotalLoss : props.handleTotalIncome;

  return (
    <>
      {
        props.lookups &&
        <table className="table-with-border pie-table accordion-content" role="presentation">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {
              props.lookups.map((attr, key) => {
                let incomeAttributesData: Record<string, unknown> | undefined = undefined;
                if (props.incomeAttributes) {
                  incomeAttributesData = props.incomeAttributes.find(({ code }) => code === attr.incomeAttributeCode);
                }
                if (attr.incomeAttributeCode === "7") {
                  if (["bip-income-attributes", "lle-income-attributes", "ltc-income-attributes", "glf-income-attributes"].includes(props.lookupType)) {
                    if (["lle-income-attributes", "ltc-income-attributes"].includes(props.lookupType)) {
                      attr["incomeAttributeDescription"] = "Other Revenue 1";
                      attr["incomeAttributeFrenchDescription"] = "Autres revenus 1";
                      return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                      data={incomeAttributesData}
                      showSubheading={false} hasInputLabel={true} isPlaceHolderWithAttrDesc={true}
                      isOtherLabel={false}
                      handleCommentChange={props.handleCommentChange}
                      valueChangeHandler={valueChangeHandler} isRequiredField={false} />
                    } else {
                      return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                      data={incomeAttributesData}
                      showSubheading={false} hasInputLabel={true} isOtherLabel={true}
                      handleCommentChange={props.handleCommentChange}
                      valueChangeHandler={valueChangeHandler} isRequiredField={false} />
                    }
                  } else {
                    return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                      data={incomeAttributesData}
                      showSubheading={false} hasInputLabel={true} isPlaceHolderWithAttrDesc={true}
                      isOtherLabel={false}
                      handleCommentChange={props.handleCommentChange}
                      valueChangeHandler={valueChangeHandler} isRequiredField={false} />
                  }
                } else if (attr.incomeAttributeCode === "12" && props.lookupType === "htl-income-attributes") {
                  return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                    data={incomeAttributesData}
                    showSubheading={false} hasInputLabel={false} isOtherLabel={false}
                    handleCommentChange={props.handleCommentChange}
                    valueChangeHandler={valueChangeHandler} isRequiredField={true} />
                } else if (["145", "30", "20"].includes(attr.incomeAttributeCode)) {
                  if (props.lookupType === "ltc-income-attributes") {
                    // attr["incomeAttributeDescription"] = "Other Income";
                    // attr["incomeAttributeFrenchDescription"] = "Autres revenus";
                  }
                  return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                    data={incomeAttributesData}
                    showSubheading={false} hasInputLabel={true} isPlaceHolderWithAttrDesc={true}
                    isOtherLabel={false}
                    handleCommentChange={props.handleCommentChange}
                    valueChangeHandler={valueChangeHandler} isRequiredField={false} />
                } else if (String(attr.incomeAttributeCode) === '159' && props.lookupType === "ltc-income-attributes") {
                  // attr["incomeAttributeDescription"] = "Reported Vacancy %";
                  // attr["incomeAttributeFrenchDescription"] = "Inoccupation déclarée en %";
                  return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                    data={incomeAttributesData}
                    showSubheading={false} hasInputLabel={false} isOtherLabel={false}
                    handleCommentChange={props.handleCommentChange}
                    errorMatcher={incomeAttributePercentMatcher}
                    valueChangeHandler={valueChangeHandler} isRequiredField={false} fieldType="percent" maxVal={true} />
                } else if (String(attr.incomeAttributeCode) === '8' || attr.incomeAttributeCode === '153') {
                  return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                    data={incomeAttributesData}
                    showSubheading={false} hasInputLabel={true} isPlaceHolderWithAttrDesc={true}
                    isOtherLabel={false}
                    handleCommentChange={props.handleCommentChange}
                    valueChangeHandler={valueChangeHandler} isRequiredField={false} />
                } else if (String(attr.incomeAttributeCode) !== "28") {
                  return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                    data={incomeAttributesData}
                    showSubheading={false} hasInputLabel={false} isOtherLabel={false}
                    handleCommentChange={props.handleCommentChange}
                    valueChangeHandler={valueChangeHandler} isRequiredField={false} />
                } else {
                  return <></>
                }
              }
              )
            }
          </tbody>
        </table>
      }
    </>
  );
}
